import * as Sentry from "@sentry/react";

import { call, put, takeLatest } from "redux-saga/effects";

import { AxiosResponse } from "axios";
import { BASE_API_URL } from "../../config";
import { actions } from "./slice";
import { createRequest } from "../../utils/requestUtils";

export function* giveConsent({
  payload,
}: ReturnType<typeof actions.requestGiveConsent>) {
  const { caseId } = payload;
  const sentryContext = { name: "Consent", function: "giveConsent" };
  const url = `${BASE_API_URL}/cases/${caseId}/interview/start`;
  try {
    const { status }: AxiosResponse = yield call(createRequest, {
      method: "post",
      url: url,
    });

    // If http status is 200, consent was successfully submitted
    if (status === 200) {
      yield put(actions.requestGiveConsentSuccessful(true));
    } else {
      Sentry.setTag("apiUrl", url);
      Sentry.setTag("httpCode", status);
      Sentry.setTag("function", "giveConsent");
      Sentry.setContext("saga", { ...sentryContext, httpCode: status });
      Sentry.captureEvent({
        message: "Unable to register consent",
      });
      yield put(
        actions.requestGiveConsentFailed(
          `Kunne ikke gi samtykke, feil svarkode: "${status}"`,
        ),
      );
    }
  } catch (error) {
    Sentry.setTag("apiUrl", url);
    Sentry.setTag("function", "giveConsent");
    Sentry.setContext("saga", sentryContext);
    Sentry.captureEvent({
      message: "Unable to register consent",
    });
    const errorMessage = error instanceof Error ? error.toString() : "error";
    yield put(actions.requestGiveConsentFailed(errorMessage));
  }
}

function* consentSaga() {
  yield takeLatest(actions.requestGiveConsent, giveConsent);
}

export default consentSaga;
